// ── NoteForm ──
import { Btn, FInput, Field, Modal } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const NoteForm = ({ initial, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
      const [f, set] = useFreshForm(initial || {}, "Notes");
      const ro = { padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", color:"#333" };
      const fmtD = d => d ? new Date(d).toLocaleString("en-US") : "—";
      return <Modal title={readOnly ? "View Note" : "Edit Note"} onClose={closeModal}
        onEdit={readOnly && role.canEdit ? () => { closeModal(); setModal({ type:"note-edit", rec:initial, onDone:modal.onDone }); } : null}>
        <Field label="Type"><div style={ro}>{f.entitytype || "—"}</div></Field>
        <Field label="Source"><div style={ro}>{f.source || "—"}</div></Field>
        <Field label="Note">
          {readOnly
            ? <div style={{ ...ro, whiteSpace:"pre-wrap", minHeight:60 }}>{f.note || "—"}</div>
            : <textarea value={f.note || ""} onChange={e => set("note")(e.target.value)} rows={5}
                style={{ width:"100%", padding:"8px 10px", fontSize:13, border:"1px solid #ccc", borderRadius:4, resize:"vertical", boxSizing:"border-box" }} />}
        </Field>
        <Field label="Note Date">
          {readOnly
            ? <div style={ro}>{f.notedate ? f.notedate.slice(0,10) : "—"}</div>
            : <FInput value={f.notedate?.slice(0,10) || ""} onChange={set("notedate")} type="date" />}
        </Field>
        <Field label="Created By"><div style={ro}>{f.createdby || "—"}</div></Field>
        <Field label="Created At"><div style={ro}>{fmtD(f.createdat)}</div></Field>
        {!readOnly && error && <div style={{ color:"#993C1D", fontSize:12, marginBottom:8, marginTop:8 }}>{error}</div>}
        <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:8 }}>
          <Btn onClick={closeModal}>{readOnly ? "Close" : "Cancel"}</Btn>
          {!readOnly && <Btn disabled={saving} variant="primary"
            onClick={() => saveRec("saveNote", { id:f.id, note:f.note, notedate:f.notedate, source:f.source }, "Edited", "Notes", "Updated note", modal.onDone)}>
            {saving ? "Saving..." : "Save"}</Btn>}
        </div>
      </Modal>;
    }; 
